export default "__VITE_ASSET__D2gcpJKE__"